import { SheetManagementSet } from '../../types/sheet/draft';
import FastFormulaParser, { IFormulaParser } from './fast-formula-parser';
import { Index } from './functions';
import { HLookUp, VLookUp } from './functions/lookup';
import { Match } from './functions/match';
import { Max, Min } from './functions/math';
import { Concatenate } from './functions/text';
import {
  IOnCell,
  IOnRange,
  SheetsDataSetForParser,
  onCell,
  onRange,
} from './helper';

class ParserSingleton {
  private static instance: ParserSingleton;
  private parser: IFormulaParser | undefined;
  private sheetsDataSet: SheetsDataSetForParser | undefined;

  private constructor() {
    this.parser = this.createParser();
  }

  private createParser(): IFormulaParser {
    return new FastFormulaParser({
      functions: {
        MATCH: Match,
        MAX: Max,
        MIN: Min,
        VLOOKUP: VLookUp,
        HLOOKUP: HLookUp,
        INDEX: Index,
        CONCATENATE: Concatenate,
      },
      onCell: (info: IOnCell) => onCell(info, this.sheetsDataSet),
      onRange: (info: IOnRange) => onRange(info, this.sheetsDataSet),
    });
  }

  public static getInstance(): ParserSingleton {
    if (!ParserSingleton.instance) {
      ParserSingleton.instance = new ParserSingleton();
    }
    return ParserSingleton.instance;
  }

  public parse(
    formula: string,
    sheetsDataSet: SheetsDataSetForParser,
    cellInfo: IOnCell
  ): any {
    if (!this.parser) {
      throw new Error('Parser not initialized');
    }
    
    ParserSingleton.instance.sheetsDataSet = sheetsDataSet;
    const result = this.parser.parse(formula, cellInfo);

    // Reset sheets
    ParserSingleton.instance.sheetsDataSet = undefined;
    return result;
  }
}

const FormulaParser = ParserSingleton.getInstance();

export default FormulaParser;
